import React from 'react';
import ProfilePageContent from './ProfilePageContent';
import styles from './ProfilePage.module.scss';
import { useSelectedContext } from 'context/contextSelector';
import { Link } from 'react-router-dom';

export const ProfilePage = ({ isFourOhFour, userData, setUserData }) => {
  const { user } = useSelectedContext((context) => context.user);

  return (
    <div className={styles.container}>
      {isFourOhFour ? (
        <div className={styles.deletedUser}>
          <div className={styles.deletedText}>
            <p>This user is no longer available</p>
            <p>
              Go to the <Link to="/dashboard/feed">homepage</Link>
            </p>
          </div>
        </div>
      ) : (
        <>
          <ProfilePageContent
            userProps={userData}
            setUserProps={setUserData}
            isCurrentUser={userData.id === user.id}
            selectUser={userData.status}
          />
        </>
      )}
    </div>
  );
};
